// Canonical names for the marketplace analytics events emitted client-side.
// Server-emitted events (purchases, listings, payouts, reviews, favorites) are
// emitted from the Ruby ops as inline string literals on the analytics adapter
// (matching the existing `user_signed_up` convention) — keep the event names
// here in sync with those. Naming follows `object_action`, past tense.
export const analyticsEvents = {
  // Buyer (demand) discovery & intent — captured via usePostHog()
  marketplaceViewed: "marketplace_viewed",
  productViewed: "product_viewed",
  checkoutStarted: "checkout_started",

  // Destination ranking telemetry. Every one carries the `ranking_version` the
  // page was rendered under, so a change in what families click can be
  // attributed to the ranking change that caused it rather than to the season.
  destinationResultsViewed: "destination_results_viewed",
  destinationResultClicked: "destination_result_clicked",
  destinationResultSaved: "destination_result_saved",
} as const;

// The PostHog group type for the seller account (Group Analytics).
export const ACCOUNT_GROUP = "account";

export type AnalyticsEvent = (typeof analyticsEvents)[keyof typeof analyticsEvents];
